import React, { useState, useContext, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import ContextComponent from "../../../AppContext";
import Utils from "../../../Utils";
import DataTable from "../../../controls/table/DataTable";
import BulkUploadIcon from "../../../../assets/img/Upload.png";
import AddIcon from "../../../../assets/img/add.png";
import EditIcon from "../../../../assets/img/Edit.png";
import ResetPasswordIcon from "../../../../assets/img/settings.png";
import DeleteIcon from "../../../../assets/img/Delete.png";
import defaultUserImage from "../../../../assets/img/default-profile.png";
import AddUserPage from "./AddUserPage";
import EditUserPage from "./EditUserPage";
import EmptyPage from "./../../../pages/EmptyPage";
import UsersBulkUpload from "./UsersBulkUpload";

const UsersTable = () => {
  let [showDeleteModal, setShowDeleteModal] = useState(false);
  let [selectedItemCount, setSelectedItemCount] = useState(0);

  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
  let [resetPasswordIconClass, setResetPasswordIconClass] =
    useState(DISABLED_ICON);

  let [tableSelectedItems, setTableSelectedItems] = useState([]);
  let [userIdForEdit, setUserIdForEdit] = useState("");
  let [usersForResetPassword, setUsersForResetPassword] = useState([]);
  let [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  let [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
      setUserIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);
      setUserIdForEdit("");
    }
    if (tableSelectedItems.length > 0) {
      setResetPasswordIconClass("");
      setUsersForResetPassword(tableSelectedItems);
      let tempUsers = [];
      allUsers.forEach((user) => {
        tableSelectedItems.indexOf(user.id) > -1 && tempUsers.push(user);
      });
      setUsersForResetPassword(tempUsers);
    } else {
      setResetPasswordIconClass(DISABLED_ICON);
      setUsersForResetPassword([]);
    }
  }, [tableSelectedItems]);

  let [editModalCanOpen, setEditModalCanOpen] = useState(false);
  let [editableUser, setEditableUser] = useState({});
  let [editableUserIndex, setEditableUserIndex] = useState(-1);

  const openEditModal = (e) => {
    e.preventDefault();
    setEditModalCanOpen(true);
    let targetUser = {};
    allUsers.forEach((user, index) => {
      if (user.id === userIdForEdit) {
        targetUser = user;
        setEditableUserIndex(index);
      }
    });
    //console.log(targetUser);
    !Utils.isObjectEmpty(targetUser) && setEditableUser(targetUser);
  };

  let { setCanRedirectToLogin, setLoadingState, userData, setAlert } =
    useContext(ContextComponent);

  let [tableColumns, setTableColumns] = useState([
    "id",
    "select",
    "salutation",
    "firstName",
    "lastName",
    "pronoun",
    "region",
    "email",
    "department",
    "brand",
    "title",
    "admin",
  ]);
  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
    },
    salutation: {
      type: "text",
      search: false,
      sort: false,
      title: "Salutation",
    },
    firstName: {
      type: "text",
      search: true,
      sort: true,
      title: "First name",
    },
    lastName: {
      type: "text",
      search: true,
      sort: true,
      title: "Last name",
    },
    pronoun: {
      type: "text",
      title: "Pronoun",
    },
    region: {
      type: "text",
      title: "Region",
    },
    email: {
      type: "text",
      search: true,
      title: "Email",
    },
    department: {
      type: "text",
      title: "Department",
    },
    brand: {
      type: "text",
      title: "Brand",
    },
    title: {
      type: "text",
      title: "Title",
    },
    admin: {
      type: "boolean",
      title: "admin",
      disabled: true,
      center: true,
    },
  });

  let [tableData, setTableData] = useState([]);
  let [canRender, setCanRender] = useState(false);
  let [renderDataTable, setRenderDataTable] = useState(false);
  let [renderEmptyPage, setRenderEmptyPage] = useState(false);
  let [updateTable, setUpdateTable] = useState(false);

  const updateTableData = (data) => {
    setAllUsers(data);
    let userInfo = data;
    let usersArray = [];
    if (!Utils.isObjectEmpty(userInfo)) {
      usersArray = userInfo.map((user, index) => {
        let userTableObj = [];
        let userTableData = [];
        tableColumns.forEach((col) => {
          if (col === "salutation") {
            let salutationValue = userInfo[index][col]
              ? Utils.SALUTATION[userInfo[index][col]]
              : "";
            userTableData.push(salutationValue);
          } else if (col === "pronoun") {
            let pronounValue = userInfo[index][col]
              ? Utils.PRONOUNS[userInfo[index][col]]
              : "";
            userTableData.push(pronounValue);
          } else if (col === "region") {
            let regionValue = userInfo[index][col]
              ? Utils.REGIONS[userInfo[index][col]]
              : "";
            userTableData.push(regionValue);
          } else if (col === "select") {
            userTableData.push(false);
          } else if (col === "admin") {
            let isSuperAdmin = userInfo[index]['superAdmin'];
            let valueToBePush = isSuperAdmin ? Utils.APP_CONSTANTS.DOUBLE_TICK : userInfo[index][col];
            userTableData.push(valueToBePush);
          } else if (col === "brand") {
            userTableData.push(userInfo[index].brands.join(", "));
          } else if (col === "username") {
            userTableData.push(
              userInfo[index].firstName + " " + userInfo[index].lastName
            );
          } else {
            userTableData.push(userInfo[index][col]);
          }
        });
        userTableObj = userTableData;
        return userTableObj;
      });

      setTableData(usersArray);
      setCanRender(true);
    }
  };

  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    updateTableData(res.data);

    setRenderDataTable(res.data.length !== 0);
    setRenderEmptyPage(res.data.length === 0);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadAllUsers = () => {
    Utils.getAllUsers().then(success, fail);
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading users",
    });
    loadAllUsers();
  }, []);

  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleResetPasswordShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowResetPasswordModal(true);
    }
  };

  const handleResetPasswordClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowResetPasswordModal(false);
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const handleDelete = async (e) => {
    //debugger;
    setShowDeleteModal(false);
    // setLoadingState({
    //   applyMask: true,
    //   text: "Deleting selected " + tableSelectedItems.length + " items",
    // });
    let tempTableData = tableData.filter((d) => {
      return tableSelectedItems.indexOf(d[0]) === -1;
    });
    setTableData(tempTableData);
    Utils.deleteUsers(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  const resetPasswordSuccess = (res) => {
    setLoadingState({
      applyMask: false
    });
    setAlert({
      show: true,
      message: "Resetting password successfully done!",
    });
  };

  const resetPasswordFail = (err) => {
    err?.message?.length && console.log(err);
    setLoadingState({
      applyMask: false
    });
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const handleResetPassword = async (e) => {
    setShowResetPasswordModal(false);
    setLoadingState({
      applyMask: true,
      text: "Resetting passwords",
    });
    Utils.resetPasswordUsers(tableSelectedItems).then(
      resetPasswordSuccess,
      resetPasswordFail
    );
  };

  let [addModalCanOpen, setAddModalCanOpen] = useState(false);
  let [bulkUploadModalCanOpen, setBulkUploadModalCanOpen] = useState(false);

  const openBulkUploadModal = (e) => {
    e.preventDefault();
    setBulkUploadModalCanOpen(true);
  };

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };

  const closeAddModal = (e) => {
    setAddModalCanOpen(false);
  };

  const saveAction = (data) => {
    //console.log(data);
  };

  let REGIONS = Utils.REGIONS;
  let sortedRegions = Object.keys(REGIONS).sort();

  const regionHandler = (e) => {
    let regionId = e.currentTarget.value;
    setLoadingState({
      applyMask: true,
      text: "Filtering users table",
    });

    if (regionId === "clear") {
      loadAllUsers();
    } else {
      const usersFilterSuccess = (res) => {
        console.log(res);
        updateTableData(res.data);
      };
      const usersFilterFail = (err) => {
        err?.message?.length && console.log(err);
        if (err?.redirect) {
          setCanRedirectToLogin(true);
        }
      };

      Utils.getFilteredUsers("region", regionId).then(success, fail);
    }
  };

  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        Users
        <div className="d-none1 w-50 indi-body-actions">
          <div className="indi-body-action">
            {/* <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img> */}
            <FloatingLabel label="">
              <Form.Select
                defaultValue="clear"
                id="region"
                size="sm"
                className="indi-input-field indi-input-select-field indi-users-table-region-dropdown"
                onChange={regionHandler}
              >
                <option value="clear">All</option>
                {sortedRegions.map((keyName, index) => (
                  <option value={keyName} key={index}>
                    {REGIONS[keyName]}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </div>
          <div
            className="indi-body-action"
            role="button"
            onClick={openBulkUploadModal}
          >
            <img
              className="indi-w-24 indi-bulk-upload-img"
              src={BulkUploadIcon}
              alt="Bulk-upload-icon"
            ></img>
            Bulk upload
          </div>
          <div
            className="indi-body-action"
            role="button"
            onClick={openAddModal}
          >
            <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
            Add
          </div>

          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>

          <div
            className={`indi-body-action ${resetPasswordIconClass}`}
            role="button"
            onClick={handleResetPasswordShow}
          >
            <img
              className="indi-w-20"
              src={ResetPasswordIcon}
              alt="Reset-password-icon"
            ></img>
            Reset password
          </div>
        </div>
      </div>
      {canRender && (
        <>
          {renderDataTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
              }}
            />
          )}
          {!renderDataTable && (
            <EmptyPage
              props={{
                emptyMessage: "No users are available",
              }}
            />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete select {selectedItemCount} user(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addModalCanOpen && (
        <AddUserPage
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            tableData,
            setTableData,
            loadAllUsers,
          }}
        />
      )}

      {editModalCanOpen && (
        <EditUserPage
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            tableData,
            setTableData,
            editableUser,
            editableUserIndex,
            allUsers,
            setAllUsers,
            loadAllUsers,
          }}
        />
      )}

      <Modal
        centered
        show={showResetPasswordModal}
        onHide={handleResetPasswordClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure to reset the below user(s)?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {usersForResetPassword.map((user, index) => (
              <div key={index}>
                <img
                  className="indi-header-profile-image"
                  src={
                    user?.profileImage?.length > 0
                      ? user?.profileImage
                      : defaultUserImage
                  }
                  alt={user.firstName}
                  title={user.firstName}
                />
                <span className="indi-reset-user-password-list-item">{user.firstName} {user.lastName}</span>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleResetPasswordClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleResetPassword}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {bulkUploadModalCanOpen && (
        <UsersBulkUpload
          props={{
            addModalCanOpen: bulkUploadModalCanOpen,
            setAddModalCanOpen: setBulkUploadModalCanOpen,
            tableData,
            setTableData,
            success,
          }}
        />
      )}
    </div>
  );
};

export default UsersTable;
